import { DICTIONARY_SKILLS } from "../Constants";

export const getSkillName = (key: keyof typeof DICTIONARY_SKILLS): string => {
  if (!DICTIONARY_SKILLS[key]) {
    return key;
  }
  return DICTIONARY_SKILLS[key];
};
